<div class="appointment-list">
	<header>
		<span class="todays-date" id="open-calendar">
			<!-- LOC-1086 -->
			{{ myDate | date: "M/d/yyyy" }}
			<ion-icon icon="calendar-outline" style="padding-left:10px"></ion-icon>
			<ion-popover trigger="open-calendar" show-backdrop="true">
				<ng-template>
					<ion-datetime presentation="date" [showDefaultButtons]="true"
								  [min]="zeroTime(addDays(getTodaysDate(), -1).toISOString())" [max]="zeroTime(addDays(getTodaysDate(), 5).toISOString())"
								  [(ngModel)]="myDate" (ionChange)="onDateChange()">
					</ion-datetime>
				</ng-template>
			</ion-popover>
		</span>
	</header>
	<ng-container *ngIf="isLoading">
		<ion-list mode="md">
			<app-appointment-list-item-skeleton
				*ngFor="let ghost of [1, 1, 1]"
			></app-appointment-list-item-skeleton>
		</ion-list>
	</ng-container>
	<ng-container *ngIf="!isLoading">
		<ion-list *ngIf="hasAppointments(); else empty" mode="md">
			<app-appointment-list-item
				*ngFor="let appointment of appointments; index as index"
				[appointment]="appointment"
				[dataTabPreview]="appointment.dataTab[0]"
			></app-appointment-list-item>
		</ion-list>

		<ng-template #empty>
			<div class="empty">
				No appointments scheduled
			</div>
		</ng-template>
	</ng-container>
</div>
